import { useState } from 'react';
import { Link } from 'react-router-dom';

import testimoniosData from '../../data/Testimoniosdata';
import { useIdioma } from '../../context/IdiomaContext';

import './TestimoniosInicio.css';

function TestimoniosInicio() {
  const { idioma, t } = useIdioma();

  const [testimoniosAleatorios] = useState(
    () => {
      return [...testimoniosData]
        .sort(() => Math.random() - 0.5)
        .slice(0, 3);
    }
  );

  const obtenerTextoTraducido = (contenido) => {
    if (
      typeof contenido === 'object' &&
      contenido !== null
    ) {
      return (
        contenido[idioma] ||
        contenido.es ||
        ''
      );
    }

    return contenido;
  };

  return (
    <section className="testimonios-inicio">
      <h2>
        {t('testimoniosInicio.titulo')}
      </h2>

      <div className="testimonios-inicio-container">
        {testimoniosAleatorios.map(
          (testimonio) => (
            <article
              className="testimonio-card"
              key={testimonio.id}
            >
              <blockquote>
                «
                {obtenerTextoTraducido(
                  testimonio.testimonial
                )}
                »
              </blockquote>

              <div className="testimonio-autor">
                <p>{testimonio.name}</p>

                <span>
                  {obtenerTextoTraducido(
                    testimonio.position
                  )}
                </span>
              </div>
            </article>
          )
        )}
      </div>

      <Link
        to="/testimonios"
        className="ver-testimonios"
      >
        {t(
          'testimoniosInicio.verTodos'
        )}
      </Link>
    </section>
  );
}

export default TestimoniosInicio;